import {Form, Input, Modal} from "antd";
import {useState} from "react";
import {DialogProps} from "components/Modal/DialogProps";
import {email} from "utilities/formRules";
import {useEditUser} from "hooks/useEditUser";

interface Props {
  userId: number
}

export const EditEmailDialog = ({ open, onClose, userId }: DialogProps & Props) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const editUser = useEditUser();

  const handleOk = async () => {
    const values = await form.validateFields();
    setLoading(true);
    await editUser({
      userId,
      ...values
    });
    setLoading(false);
    onClose();
  };

  return <Modal title="Edit e-mail address"
                open={open}
                onOk={handleOk}
                confirmLoading={loading}
                onCancel={onClose}
  >
    <Form form={form} layout="vertical" requiredMark={false}>
      <Form.Item name="mailAddress" label="New e-mail address" rules={email}>
        <Input type='email' />
      </Form.Item>
    </Form>
  </Modal>
}